/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespTradeSourcingBanner_user$ref: FragmentReference;
export type SbRespTradeSourcingBanner_user = {|
  +isVerifiedTrade: ?boolean,
  +$refType: SbRespTradeSourcingBanner_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespTradeSourcingBanner_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '586c982215b6e1a9d0efc8670c337f7a';
module.exports = node;
